// UUID v4 generator — copied from views_shared for V1 standalone use
export default function generateUuid() {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);

  // eslint-disable-next-line no-bitwise
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
  // eslint-disable-next-line no-bitwise
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 1

  return [bytes.slice(0, 4), bytes.slice(4, 6), bytes.slice(6, 8), bytes.slice(8, 10), bytes.slice(10, 16)]
    .map((part) => Array.from(part)
        .map((b) => b.toString(16).padStart(2, '0'))
        .join(''))
    .join('-');
}
